import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const BannerThree = () => {
    return(
        <>
        <section className="slider">

                <OwlCarousel 
                items={1}
                loop={true}
                nav={true}
                dots={true}
                autoplay={true}
                animateIn={'fadeIn'}
                animateOut={'fadeOut'}
                navText={['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']}
                className="slider-carousel owl-carousel owl-theme">
                    <div className="slide" style={{backgroundImage:'url("images/slider/sl-01-1920x750.png")'}}>
                        <div className="container">
                            <div className="content">
                                <h3>We Have</h3>
                                <h2>Qualified Attorneys</h2>
                                <div className="text">We Alawys Provide you awesome theme With high quality design!<br /> Your will be very happy to get this theme.</div>
                                <div className="link-holder">
                                    <Link to="#" className="o-btn btn-style-nine">Read more</Link>
                                </div>
                            </div>
                        </div> 
                    </div>

                    <div className="slide" style={{backgroundImage:'url("images/slider/sl-02-1920x750.png")'}}>
                        <div className="container">
                            <div className="content">
                                <h3 className="style-two">Experience.Advice</h3>
                                <h2>Success</h2>
                                <div className="text">We Alawys Provide you awesome theme With high quality design! <br />Your will be very happy to get this theme. </div>
                                <div className="link-holder">
                                    <Link to="#" className="o-btn btn-style-nine">Read more</Link> <Link to="#" className="o-btn btn-style-eight">Our Servics</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </OwlCarousel>
        </section>
        </>
    )
}

export default BannerThree;